export default {
  localidad: {},
  localidades: [],
};
